import { render, staticRenderFns } from "./UserAgreementText.vue?vue&type=template&id=462aaa59&lang=pug"
import script from "./UserAgreementText.vue?vue&type=script&lang=js"
export * from "./UserAgreementText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports